export enum RoleKey {
  Admin = "admin",
  ItAdmin = "it_admin",
  BusinessAdmin = "business_admin",
  CarrierVisitor = "carrier_visitor",
  Supervisor = "supervisor",
  VisitorA = "visitor_a",
  VisitorB = "visitor_b",
  VisitorC = "visitor_c",
  Carrier = "carrier",
  Collector = "collector",
  CallCenter = "call_center",
  Viewer = "viewer",
}

export const ADMIN_ROLES = new Set<RoleKey>([
  RoleKey.Admin,
  RoleKey.ItAdmin,
  RoleKey.BusinessAdmin,
]);

export const BLOCKED_ROLES_FOR_SUPERVISOR = new Set<RoleKey>([
  RoleKey.Admin,
  RoleKey.ItAdmin,
  RoleKey.BusinessAdmin,
  RoleKey.CarrierVisitor,
]);
